import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { SettingDefinitionQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ISettingDefinition } from "../../models/SettingDefinition/SettingDefinition";

export default function useSettingDefinitions(includeArchived = false) {
  const { get } = useApiHelper();

  const settingDefinitions = useQuery({
    queryKey: SettingDefinitionQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponse<ISettingDefinition[]>>(
        `/settingDefinition?includeArchived=${includeArchived}`
      ).then((res) => res.data),
  });

  return {
    settingDefinitions,
  };
}
